var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgClock(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 44,
    viewBox: "0 0 44 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_19_1205)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M33.0458 21.218H24.0711C23.3592 21.218 22.782 20.6408 22.782 19.9289V10.9542C22.782 10.1381 22.1208 9.48175 21.3096 9.48175C20.4978 9.48175 19.8373 10.1424 19.8373 10.9542V22C19.8373 22.5777 20.0623 23.1208 20.4706 23.5295C20.879 23.9377 21.4223 24.1628 22 24.1628H33.0458C33.8576 24.1628 34.5182 23.5022 34.5182 22.6903C34.5182 21.8744 33.857 21.218 33.0458 21.218Z",
    fill: "#FDC93C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 0C9.86915 0 0 9.86915 0 22C0 34.1309 9.86915 44 22 44C34.1309 44 44 34.1309 44 22C44 9.86915 34.1309 0 22 0ZM33.0458 26.7409H22C19.3774 26.7409 17.2591 24.6185 17.2591 22V10.9542C17.2591 8.72077 19.0761 6.90362 21.3096 6.90362C23.5635 6.90362 25.3601 8.73177 25.3601 10.9542V18.6398H33.0457C35.304 18.6398 37.0962 20.4726 37.0962 22.6903C37.0964 24.9238 35.2792 26.7409 33.0458 26.7409Z",
    fill: "#FDC93C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_19_1205"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 44,
    height: 44,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/Clock.d9c6c32896cf0a0bd2e1ba3a8d775075.svg";
export { ForwardRef as ReactComponent };